/**
 * Route path constants
 * Centralized route definitions for type-safe navigation
 */
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    TOOLS: '/apps',
    COURSES: '/courses',
    NEWS: '/news',
    SUGGESTED_AI_TOOLS: '/suggest-ai-tools',
    RESPONSIBLE_USE_OF_AI: '/responsible-use-of-ai',
    DASHBOARD: '/dashboard',
    PROFILE: '/profile',
    SETTINGS: '/settings',
    SHOWCASE: '/showcase',
    DOCS: '/docs',
    ABOUT: '/about',
    CONTENT_DETAIL: '/content-detail',
    CONTENT_DETAIL_V1: '/content-detail/v1',
    CONTENT_DETAIL_V2: '/content-detail/v2',
    CONTENT_DETAIL_V3: '/content-detail/v3',
    UNAUTHORIZED: '/unauthorized',
    NOT_FOUND: '*',
} as const;

/** URL query param used to pre-select "Filter by type" (course tag IDs, comma-separated) on the All Courses page */
export const COURSE_TYPE_QUERY_PARAM = 'type';

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = typeof ROUTES[RouteKey];
